<i18n lang="json">
{
  "en": {
    "noPrice": "Inquire for pricing",
    "disclaimer": "All advertised prices may be subject to taxes, licenses, dealer processing, and other fees. RVezy.com is not responsible for the accuracy of the information."
  },
  "fr": {
    "noPrice": "Demander le prix",
    "disclaimer": "Tous les prix annoncés peuvent être soumis à des taxes, licences, frais de traitement du concessionnaire et autres frais. RVezy.com n'est pas responsable de l'exactitude des informations."
  }
}
</i18n>

<template>
  <div class="typography-subtitle-3 mb-5">
    <template v-if="askingPrice">
      <div class="flex items-center gap-1">
        {{
          useCurrency().getValueWithCurrency({
            amount: askingPrice,
            country: country
          })
        }}
        <IconCircleQuestionMark
          class="text-highlight cursor-pointer"
          @click="togglePriceDisclaimer"
          ref="priceDisclaimerIcon"
        />
        <ClientOnly>
          <Tooltip
            :reference-element="priceDisclaimerIcon"
            :show="showPriceDisclaimer"
            :content="t('disclaimer')"
            @close="togglePriceDisclaimer(false)"
          />
        </ClientOnly>
      </div>
      <div v-if="msrpPrice" class="typography-subtitle-0 text-primary-200 line-through">
        {{
          useCurrency().getValueWithCurrency({
            amount: msrpPrice,
            country: country
          })
        }}
      </div>
    </template>
    <template v-else>{{ t('noPrice') }}</template>
  </div>
</template>

<script setup lang="ts">
import type { IconCircleQuestionMark } from '#build/components'

defineProps<{
  askingPrice?: number
  msrpPrice?: number
  country?: string
}>()

const { t } = useI18n()

const showPriceDisclaimer = ref(false)
const priceDisclaimerIcon = ref<InstanceType<typeof IconCircleQuestionMark>>()

const togglePriceDisclaimer = (open?: boolean) => {
  showPriceDisclaimer.value = open ?? !showPriceDisclaimer.value
}
</script>
